import client from '../config/AxiosConfig';

export const GetExternalSuppliers = async (currentPage, limit, filters = {}) =>
  client.get(`/externalSuppliers/${currentPage}/${limit}?filter=${JSON.stringify(filters)}`);

export const GetExternalSuppliersByCategory = async (category) =>
  client.get(`/externalSuppliers/category/${category}`);